__turbopack_context__.v({
  "AddButton": "_1wFQ-q_AddButton",
  "DragHandle": "_1wFQ-q_DragHandle",
  "LevelItem": "_1wFQ-q_LevelItem",
  "LevelNumber": "_1wFQ-q_LevelNumber",
  "LevelsList": "_1wFQ-q_LevelsList",
  "RemoveButton": "_1wFQ-q_RemoveButton",
  "Root": "_1wFQ-q_Root",
  "Select": "_1wFQ-q_Select",
  "skeleton-loading": "_1wFQ-q_skeleton-loading",
});
